module.exports = __webpack_public_path__ + "static/media/healthcare.0707de1f.gif";